import React, { useEffect, useState } from 'react';
import { getResumenRetenciones, getCertificadoRetencionBlob } from '../services/api';

const TIPOS = [
  { id: 'fuente', label: 'Retención en la Fuente', sub: 'Renta' },
  { id: 'iva',    label: 'ReteIVA',                 sub: 'IVA' },
  { id: 'ica',    label: 'ReteICA',                 sub: 'ICA' },
];
const BIMESTRES = [['anio', 'Todo el año'], ['1', 'Bim 1 · Ene-Feb'], ['2', 'Bim 2 · Mar-Abr'], ['3', 'Bim 3 · May-Jun'], ['4', 'Bim 4 · Jul-Ago'], ['5', 'Bim 5 · Sep-Oct'], ['6', 'Bim 6 · Nov-Dic']];
const fmt = (n) => '$' + Number(n || 0).toLocaleString('es-CO', { maximumFractionDigits: 0 });

function rango(anio, periodo) {
  if (periodo === 'anio') return { desde: `${anio}-01-01`, hasta: `${anio}-12-31` };
  const b = Number(periodo);
  const m1 = 2 * b - 1, m2 = 2 * b;
  const last = new Date(anio, m2, 0).getDate();
  return { desde: `${anio}-${String(m1).padStart(2, '0')}-01`, hasta: `${anio}-${String(m2).padStart(2, '0')}-${last}` };
}

export default function CertificadosRetencion() {
  const anioActual = new Date().getFullYear();
  const [tipo, setTipo] = useState('fuente');
  const [anio, setAnio] = useState(anioActual);
  const [periodo, setPeriodo] = useState('anio');
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState('');
  const [genNit, setGenNit] = useState(null);

  const buscar = async () => {
    setLoading(true); setMsg('');
    try {
      const { desde, hasta } = rango(anio, periodo);
      const { data } = await getResumenRetenciones({ tipo, desde, hasta });
      setRows(data || []);
      if (!data || !data.length) setMsg('Sin retenciones de este tipo en el período. (Se generan al causar/contabilizar las facturas de compra.)');
    } catch (e) { setMsg('❌ ' + (e.response?.data?.error || 'Error al consultar')); setRows([]); }
    finally { setLoading(false); }
  };
  useEffect(() => { buscar(); /* eslint-disable-next-line */ }, [tipo, anio, periodo]);

  const generar = async (r) => {
    setGenNit(r.nit);
    try {
      const { desde, hasta } = rango(anio, periodo);
      const { data } = await getCertificadoRetencionBlob({ tipo, nit: r.nit, desde, hasta, anio });
      const url = URL.createObjectURL(data);
      window.open(url, '_blank');
      setTimeout(() => URL.revokeObjectURL(url), 60000);
    } catch (e) {
      // el error del backend viene como blob; lo leemos
      let txt = 'No se pudo generar el certificado';
      try { txt = JSON.parse(await e.response.data.text()).error || txt; } catch {}
      setMsg('❌ ' + txt);
    } finally { setGenNit(null); }
  };

  const totalRet = rows.reduce((s, r) => s + Number(r.retenido || 0), 0);

  return (
    <div>
      <div style={s.head}>
        <div>
          <h1 style={s.h1}>Certificados de retención</h1>
          <p style={s.sub}>Certificados a proveedores por las retenciones practicadas en tus compras{rows.length ? ` · ${rows.length} proveedores · ${fmt(totalRet)} retenido` : ''}</p>
        </div>
      </div>

      {/* Controles */}
      <div style={s.controls}>
        <div style={s.seg}>
          {TIPOS.map(t => (
            <button key={t.id} onClick={() => setTipo(t.id)} style={{ ...s.segBtn, ...(tipo === t.id ? s.segOn : {}) }}>
              {t.label}<span style={s.segSub}>{t.sub}</span>
            </button>
          ))}
        </div>
        <div style={{ display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap' }}>
          <select style={s.input} value={anio} onChange={e => setAnio(Number(e.target.value))}>
            {[anioActual, anioActual - 1, anioActual - 2, anioActual - 3].map(y => <option key={y} value={y}>{y}</option>)}
          </select>
          <select style={s.input} value={periodo} onChange={e => setPeriodo(e.target.value)}>
            {BIMESTRES.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
          </select>
        </div>
      </div>

      {msg && <div style={s.msg}>{msg}</div>}

      <div style={s.card}>
        <table style={s.table}>
          <thead>
            <tr>{['Proveedor', 'NIT', 'Facturas', 'Base', 'Retenido', 'Certificado'].map(h =>
              <th key={h} style={{ ...s.th, textAlign: ['Facturas', 'Base', 'Retenido', 'Certificado'].includes(h) ? 'right' : 'left' }}>{h}</th>)}</tr>
          </thead>
          <tbody>
            {loading && <tr><td colSpan={6} style={s.empty}>Cargando…</td></tr>}
            {!loading && rows.length === 0 && <tr><td colSpan={6} style={s.empty}>Sin resultados.</td></tr>}
            {!loading && rows.map(r => (
              <tr key={r.nit}>
                <td style={{ ...s.td, color: '#e2e8f0' }}>{r.razon}</td>
                <td style={s.td}>{r.nit}</td>
                <td style={{ ...s.td, textAlign: 'right', fontFamily: 'ui-monospace' }}>{r.facturas}</td>
                <td style={{ ...s.td, textAlign: 'right', fontFamily: 'ui-monospace' }}>{fmt(r.base)}</td>
                <td style={{ ...s.td, textAlign: 'right', fontFamily: 'ui-monospace', fontWeight: 700 }}>{fmt(r.retenido)}</td>
                <td style={{ ...s.td, textAlign: 'right' }}>
                  <button style={{ ...s.btn, opacity: genNit === r.nit ? 0.6 : 1 }} disabled={genNit === r.nit} onClick={() => generar(r)}>
                    {genNit === r.nit ? 'Generando…' : '📄 Certificado'}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <p style={{ color: '#64748b', fontSize: 12, marginTop: 12 }}>
        ℹ️ Los valores se toman de las <b>facturas de compra contabilizadas</b> con retención. El firmante del certificado es el <b>responsable</b> configurado en Sistema → Configuración → Recepción DIAN.
      </p>
    </div>
  );
}

const s = {
  head: { marginBottom: 16 },
  h1: { fontSize: 24, fontWeight: 700, color: '#f1f5f9', margin: 0 },
  sub: { color: '#64748b', fontSize: 14, margin: '4px 0 0' },
  controls: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 16, flexWrap: 'wrap', marginBottom: 16 },
  seg: { display: 'inline-flex', background: '#0f172a', border: '1px solid #334155', borderRadius: 10, padding: 3, gap: 2 },
  segBtn: { display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1, background: 'none', border: 'none', color: '#94a3b8', padding: '7px 16px', borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: 'pointer' },
  segOn: { background: '#1d4ed8', color: '#fff' },
  segSub: { fontSize: 10, opacity: .8, fontWeight: 500 },
  input: { background: '#0f172a', border: '1px solid #334155', borderRadius: 8, height: 38, padding: '0 11px', color: '#f1f5f9', fontSize: 13 },
  msg: { background: '#1e293b', border: '1px solid #334155', color: '#cbd5e1', padding: '10px 14px', borderRadius: 8, marginBottom: 14, fontSize: 13 },
  card: { background: '#1e293b', border: '1px solid #334155', borderRadius: 12, overflow: 'hidden' },
  table: { width: '100%', borderCollapse: 'collapse' },
  th: { padding: '11px 14px', fontSize: 11, color: '#64748b', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '.03em', borderBottom: '1px solid #334155', background: '#172033' },
  td: { padding: '11px 14px', fontSize: 13, color: '#94a3b8', borderBottom: '1px solid #1e293b' },
  empty: { padding: 30, textAlign: 'center', color: '#475569', fontSize: 13 },
  btn: { background: '#1e293b', border: '1px solid #3b82f6', color: '#93c5fd', borderRadius: 7, padding: '6px 12px', fontSize: 12.5, fontWeight: 600, cursor: 'pointer' },
};
